import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookingFlow } from '../components/BookingFlow';
export function BookingPage() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-dark w-full max-w-md mx-auto relative" data-id="element-846">
      <BookingFlow onComplete={() => navigate('/mis-turnos')} onCancel={() => navigate(-1)} data-id="element-847" />
    </div>;
}